"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    path {\n        fill: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var EditIcon = function EditIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.29103 15.75H5.43703L12.395 8.79199L11.249 7.64599L4.29103 14.604V15.75ZM16.207 7.60399L12.457 3.83299L13.437 2.83299C13.7977 2.47233 14.228 2.29199 14.728 2.29199C15.228 2.29199 15.6657 2.47233 16.041 2.83299L17.207 4.02099C17.5684 4.36833 17.7457 4.79899 17.739 5.31299C17.7317 5.82633 17.5544 6.25666 17.207 6.60399L16.207 7.60399ZM3.45703 17.583C3.19303 17.583 2.96036 17.4823 2.75903 17.281C2.5577 17.0797 2.45703 16.847 2.45703 16.583V14.229C2.45703 14.1043 2.48136 13.983 2.53003 13.865C2.5787 13.747 2.6517 13.6393 2.74903 13.542L11.228 5.06199L14.978 8.81199L6.49903 17.292C6.4157 17.3893 6.31503 17.462 6.19703 17.51C6.07903 17.5587 5.95036 17.583 5.81103 17.583H3.45703ZM11.832 8.22899L11.249 7.64599L12.395 8.79199L11.832 8.22899Z",
    fill: "#3D3D3D"
  }));
};
var EditButton = exports.EditButton = function EditButton(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    icon: /*#__PURE__*/_react.default.createElement(EditIcon, null),
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onClick
  }));
};
EditButton.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func
};